import React, { useState, useEffect } from "react";
import ExecutetickIconLight from "../../../images/orders/execute.svg";
import ExecutetickIconDark from "../../../images/orders/tick-circle.svg";
import { useTheme } from "../../../context/ThemeContext";
import Cross from "../../../images/Builder/cross.svg";
import CrossDark from "../../../images/Builder/cross_dark.svg";

const CreateWatchlistModal = ({
  isOpen,
  newWatchlistName,
  setNewWatchlistName,
  onClose,
  onCreate,
}) => {
  const { theme } = useTheme();
  const [showMaxLengthError, setShowMaxLengthError] = useState(false);

  useEffect(() => {
    setShowMaxLengthError(newWatchlistName.length > 20);
  }, [newWatchlistName]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value.length < 20) {
      setNewWatchlistName(value);
      setShowMaxLengthError(false);
    } else {
      setShowMaxLengthError(true);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0  flex items-center justify-center z-50">
      <div className="bg-modalBg p-6 rounded-xl text-center">
        <div className="flex flex-col items-center">
          <h3 className="font-medium text-[14px] text-p300">
            Create new watchlist
          </h3>
          <p className="text-[12px] font-medium text-n500 mt-1">
            Please provide a name to your watchlist
          </p>
        </div>

        <div className="mt-4">
          <input
            type="text"
            value={newWatchlistName}
            onChange={handleInputChange}
            placeholder="Name of the watchlist"
            className="w-full p-3 border-2 border-n200  rounded-md  focus:outline-none text-p300 bg-p400 font-medium text-sm"
            onKeyDown={(e) => e.key === "Enter" && onCreate()}
          />
          {showMaxLengthError && (
            <p className="text-red-500 text-xs mt-1 text-left">
              Maximum of 20 characters are allowed
            </p>
          )}
        </div>
        <div className="flex justify-center gap-3 mt-4">
          <button
              className="border border-n200 px-4 py-2 rounded-lg "
              onClick={() => {
              onClose();
              setNewWatchlistName("");
            }}>
              <img src={theme === "dark" ? CrossDark : Cross} alt="Execute icon" className="w-3 h-3" />
            </button>
          <button
            onClick={onCreate}
            disabled={!newWatchlistName.trim()}
            className="bg-swipe-button text-p400 px-4 py-2 rounded-lg w-full text-sm font-semibold text-[12px] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
            {theme === "dark" ? (
              <img src={ExecutetickIconDark} alt="" />
            ) : (
              <img src={ExecutetickIconLight} alt="" />
            )}
            Create
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateWatchlistModal;
